import { createContext, ReactNode, useEffect } from 'react';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';

import UnifiedAddressFormAnalytics from '@r1-frontend/unified-address-form/analytics';

import { initialState, TInitialState } from './reducer/initialState';
import { initialization } from './actions';
import { reducer, TAction } from './reducer';

export type TCtxDispatch = ThunkDispatch<TInitialState, TAction>

export type TCtx = {
    analytics: UnifiedAddressFormAnalytics,
    debugMode?: boolean,
    dispatch: TCtxDispatch,
    state: TInitialState,
}

export type TContext = {
    analytics?: UnifiedAddressFormAnalytics,
    children: ReactNode,
    debugMode?: boolean,
    salePackageId?: number,
    withReissue?: boolean,
}

const defaultCtxProperties: TCtx = {
    analytics: new UnifiedAddressFormAnalytics(),
    debugMode: false,
    dispatch: () => null,
    state: initialState,
};

export const Ctx = createContext<TCtx>(defaultCtxProperties);

const Context = ({ children, debugMode = false, salePackageId, withReissue, analytics }: TContext): JSX.Element => {
    const [state, dispatch] = useThunkReducer<TInitialState, TAction>(reducer(debugMode), initialState);

    useEffect(() => {
        dispatch(initialization(salePackageId, withReissue));
    }, []);

    const providerProperties = {
        ...defaultCtxProperties,
        debugMode,
        dispatch,
        state,
    };

    if (analytics) {
        providerProperties.analytics = analytics;
    }

    return <Ctx.Provider value={providerProperties}>
        {children}
    </Ctx.Provider>;
};

export default Context;
